import SubscriptionsView from "@/views/admin/subscriptions/SubscriptionsView";

export default [
  {
    name: "pages.admin.subscriptions",
    path: "subscriptions",
    component: SubscriptionsView
  },
];
